"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.constructor");
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _newReports = require("@/api/bookSpace/newReports");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default
  },
  props: {
    blNo: {
      type: String,
      default: ''
    },
    disabledType: {
      type: Boolean,
      default: false
    },
    dataInfo: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mainId: {
      type: String,
      default: ''
    },
    inputDisable: false
  },
  data: function data() {
    var _this = this;
    var validatebkNo = function validatebkNo(rule, value, callback) {
      var passwordRule = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      var passwordRule2 = /[`~!@#$%^&()_\-+=<>?:"{}|,.\/;'\\[\]·！#￥（——）：；“”‘、，|《。》？、【】[\]]/;
      var isValidTest = passwordRule.test(value);
      var isValidTest2 = passwordRule2.test(value);
      if (value === '') {
        callback(new Error(_this.$t('home.bkNoRequire')));
      }
      if (isValidTest) {
        callback(new Error('不能输入中文或特殊字符'));
      }
      if (isValidTest2) {
        callback(new Error('不能输入中文或特殊字符'));
      }
      callback();
    };
    var validateblNo = function validateblNo(rule, value, callback) {
      var passwordRule = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      var passwordRule2 = /[`~!@#$%^&()_\-+=<>?:"{}|,.\/;'\\[\]·！#￥（——）：；“”‘、，|《。》？、【】[\]]/;
      var isValidTest = passwordRule.test(value);
      var isValidTest2 = passwordRule2.test(value);
      if (value === '') {
        callback(new Error(_this.$t('home.blNoRequire')));
      }
      if (isValidTest) {
        callback(new Error('不能输入中文或特殊字符'));
      }
      if (isValidTest2) {
        callback(new Error('不能输入中文或特殊字符'));
      }
      callback();
    };
    return {
      // dialogTableData: [],
      formData: {
        dataInfo: []
      },
      cargoListType: [{
        code: 0,
        name: 'Export'
      }, {
        code: 1,
        name: 'Reshipment'
      }],
      // form: {
      //   vesselCode: '',
      //   serviceLineCode: '',
      //   vesselName: '',
      //   voyageNo: '',
      //   voyageLeg: '',
      //   currentPage: 1,
      //   pageSize: 10,
      // },
      filterFormRules: {
        copyCount: [{
          required: true,
          message: this.$t('home.copyCountRequire'),
          trigger: 'blur'
        }]
      },
      tableRules: {
        bkNo: [{
          required: true,
          validator: validatebkNo,
          trigger: 'blur'
        }],
        // bkNo: [{required: true, message: this.$t('home.bkNoRequire'), trigger: 'blur'}],

        blNo: [{
          required: true,
          validator: validateblNo,
          trigger: 'blur'
        }]
        // blNo: [{required: true, message: this.$t('home.blNoRequire'), trigger: 'blur'}],
      },
      total: 0,
      tableData: [],
      etdDate: '',
      dialogTitle: '',
      addNumber: 0,
      bkBlNoDisabled: false,
      // 拆单自动确认 自动出号时 提单号和订舱号不可编辑
      loading: null
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    handleChange: function handleChange(index) {
      this.formData.dataInfo.forEach(function (item, idx) {
        // 将当前 index 对应的 flag 设置为 true
        // 其他的 flag 设置为 false
        item.flag = idx === index;
      });
    },
    handleApply: function handleApply() {
      var _this2 = this;
      var dataOne = this.formData.dataInfo.filter(function (item) {
        return item.flag === true;
      });
      if (dataOne.length < 1) {
        this.$message({
          message: this.$t('home.selectOrdermessage'),
          type: 'warning'
        });
      } else {
        var dataTwo = this.formData.dataInfo.map(function (item) {
          return item.bookingHeadWebComId;
        });
        var data = {
          bookingHeadWebComId: dataOne[0].bookingHeadWebComId,
          bookingHeadWebComIds: dataTwo
        };
        console.log(data, '999999977777');
        this.loading = (0, _utils.load)();
        (0, _booking.combineDataNew)(data).then(function (res) {
          if (res.success) {
            _this2.$message.success(_this2.$t('home.combinMessage'));
            _this2.$emit('handleGetTable');
          }
        }).finally(function () {
          _this2.loading.close();
        });
      }
    },
    handleCancent: function handleCancent() {
      var _this3 = this;
      this.loading = (0, _utils.load)();
      var data = {
        spliteCombinType: 1,
        id: this.mainId
      };
      (0, _newReports.cancelData)(data).then(function (res) {
        if (res.success) {
          _this3.$message({
            message: _this3.$t('home.cancelSuccess'),
            type: 'success'
          });
          _this3.$emit('handleGetTable');
        }
      }).finally(function () {
        _this3.loading.close();
      });
    },
    opened: function opened() {
      this.formData.dataInfo = this.dataInfo.map(function (item) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
          flag: false
        });
      });
      console.log(this.dataInfo);
    },
    handleSelectionChange: function handleSelectionChange(selections, row) {
      if (selections.length > 1) {
        var del_row = selections.shift();
        this.$refs.multipleTable.toggleRowSelection(del_row, false);
        this.multipleSelection = selections;
      } else {
        this.multipleSelection = selections;
      }
    },
    handleClear: function handleClear() {},
    closed: function closed() {
      this.handleClear();
    },
    handleSubimtDoApplyFt: function handleSubimtDoApplyFt() {
      var _this4 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          (0, _booking.doApplyFt)(_this4.form).then(function (res) {
            if (res.code) {
              _this4.$message.success(_this4.$t("home.ftapplyMessage"));
              _this4.$parent.ftDialogVisible = false;
            } else {
              _this4.$message.warning(res.errorMessages[0]);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleButtonClose: function handleButtonClose() {
      this.$emit('handleGetTable');
    }
  }
};